import React, { ReactNode } from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

interface RowProps {
  children?: ReactNode;
  className?: string;
}

const Layout: React.FC<RowProps> = ({ children, className }) => {
  return (
    <Row className="justify-content-md-center">
      <Col sm={6}>
        <div className={`p-3 ${className}`}>{children}</div>
      </Col>
    </Row>
  );
};

export default Layout;
